import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    initialLoading: false,
    initialErrorMessage: null,
    configurationCollection: null,

    searchLoading: false,
    searchErrorMessage: null,
    searchInfoMessage: null,
    searchResult: null,
};

const searchToolSlice = createSlice({
    name: "SearchTool",
    initialState,
    reducers: {
        clearSearchData(state) {
            state.searchLoading = false;
            state.searchErrorMessage = null;
            state.searchInfoMessage = null;
            state.searchResult = null;
        },
        getInitialSearchToolDataRequest(state) {
            state.initialLoading = true;
            state.initialErrorMessage = null;
            state.searchErrorMessage = null;
            state.configurationCollection = null;
        },
        getInitialSearchToolDataSuccess(state, action) {
            state.initialLoading = false;
            state.initialErrorMessage = null;
            state.configurationCollection = action.payload;
        },
        getInitialSearchToolDataFailure(state, action) {
            state.initialLoading = false;
            state.initialErrorMessage = action.payload;
            state.configurationCollection = null;
        },

        searchRequest(state) {
            state.searchLoading = true;
            state.searchResult = null;
            state.searchInfoMessage = null;
            state.searchErrorMessage = null;
        },
        searchSuccess(state, action) {
            state.searchLoading = false;
            state.searchResult = action.payload.response;
            state.searchInfoMessage = action.payload.warningMessage;
            state.searchErrorMessage = null;
        },
        searchFailure(state, action) {
            state.searchLoading = false;
            state.searchResult = null;
            state.searchInfoMessage = null;
            state.searchErrorMessage = action.payload;
        },
    },
});

export default searchToolSlice;
